import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/poppins/latin-600.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { AuthProvider } from './auth/AuthProvider';
import { App } from './App';
import { es } from './i18n/es';
import { initializeNativeRuntime } from './native/native-runtime';
import './styles.css';

void initializeNativeRuntime();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <IntlProvider locale="es" messages={es}>
      <BrowserRouter>
        <AuthProvider><App /></AuthProvider>
      </BrowserRouter>
    </IntlProvider>
  </StrictMode>,
);
